import { calcYearsOfExperience } from '@sly/core/helpers/date';
import cx from 'classnames';

interface AgentProfile4FieldsProps {
  familiesHelped?: number;
  yearsOfExperience?: string;
  operatingIn?: string;
  withSeniorlySince?: string;
  displayOperatingIn?: boolean;
}

function Field({
  title,
  value,
  testIDValue,
}: {
  title: string;
  value?: string | number | null;
  date?: boolean;
  testIDValue?: string;
}) {
  if (!value || value === 0) {
    return null;
  }

  return (
    <div className='w-fit'>
      <p className='font-b-m text-[#70767F]'>{title}</p>
      <p className='font-b-l font-medium' data-testid={testIDValue}>
        {value}
      </p>
    </div>
  );
}

export default function AgentProfile4Fields({
  familiesHelped,
  yearsOfExperience,
  operatingIn,
  withSeniorlySince,
  displayOperatingIn,
}: AgentProfile4FieldsProps) {
  return (
    <div
      className={cx(
        'mx-6 mt-[28px] mb-3 grid grid-cols-2 gap-x-6 md:mx-auto md:gap-x-10 lg:mx-0',
        displayOperatingIn ? 'lg:grid-cols-4' : 'lg:grid-cols-3'
      )}
    >
      <Field title='Families Helped' value={familiesHelped} />
      {yearsOfExperience && (
        <Field
          title='Years of Experience'
          value={`${calcYearsOfExperience(yearsOfExperience)} year(s)`}
        />
      )}
      <Field
        title='With Seniorly Since'
        value={
          withSeniorlySince ? new Date(withSeniorlySince).getFullYear() : null
        }
      />
      {displayOperatingIn && (
        <Field
          title='Operating In'
          value={operatingIn}
          testIDValue='operatingIn'
        />
      )}
    </div>
  );
}
